import { useId } from 'react';
import eye from '~/assets/icons/eye_2.svg';
import group from '~/assets/icons/group.svg';
import takeAuction from '~/assets/icons/take_auction.svg';
import { CollectionImage } from '~/components/collections';
import { ImgIcon } from '~/components/ui/ImgIcon';
import {
	NumberplatePreview,
	NumberPlatePreviewSize,
} from '~/components/ui/NumberplatePreview';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Apps, Currency, VehicleNumberPlate } from '~/shared';
import realtyExample from '../../assets/images/realty_example.jpg';
import tshirt from '../../assets/images/tshirt.png';
import { AppAdsTypes } from '../AppAds/AppAds.model';
import { AppAuctionTypes } from '../AppAuction/AppAuction.model';
import { getImageType } from './DefaultAppItemCard.model';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledCurrencyIcon,
	StyledImage,
	StyledImageBg,
	StyledImageContainer,
	StyledInfoContainer,
	StyledInfoHint,
	StyledInfoHintContainer,
	StyledParticipantsHint,
	StyledStatContainer,
	StyledStatsContainer,
	StyledStatsIcon,
	StyledTopContainer,
} from './DefaultAppItemCard.styled';

const DefaultAppItemCard = ({
	appType,
	type,
	price,
	priceFrom,
	gold,
	time,
	vehicleNumberPlate,
	participants,
	onClick,
}: {
	appType: Apps.Ads | Apps.Auction;
	type: AppAdsTypes | AppAuctionTypes;
	gold?: boolean;
	price?: number;
	priceFrom?: boolean;
	time?: number;
	vehicleNumberPlate?: VehicleNumberPlate;
	participants?: number;
	onClick?: () => void;
}) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const svgId = useId();

	return (
		<StyledContainer onClick={onClick} $gold={gold}>
			<StyledTopContainer>
				<StyledImageContainer $type={getImageType(type)}>
					<StyledImageBg width="230" height="155" $gold={gold}>
						<mask
							id={`mask0_${svgId}`}
							style={{ maskType: 'alpha' }}
							maskUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="230"
							height="155"
						>
							<rect width="230" height="155" rx="15" fill="white" />
						</mask>
						<g mask={`url(#mask0_${svgId})`}>
							<path d="M245 -23H345L245 177H145L245 -23Z" />
							<path d="M156 -23H256L156 177H56L156 -23Z" />
							<path d="M57 -23H157L57 177H-43L57 -23Z" />
							<path d="M-32 -23H68L-32 177H-132L-32 -23Z" />
							<rect
								opacity="0.1"
								width="230"
								height="155"
								rx="15"
								fill="url(#paint0_radial_${svgId})"
							/>
						</g>
						<defs>
							<radialGradient
								id={`paint0_radial_${svgId}`}
								cx="0"
								cy="0"
								r="1"
								gradientUnits="userSpaceOnUse"
								gradientTransform="translate(115 48) rotate(90) scale(107 158.774)"
							>
								<stop stopOpacity="0" />
								<stop offset="1" />
							</radialGradient>
						</defs>
					</StyledImageBg>
					{getImageType(type) === 'vehicle' && (
						<CollectionImage
							collection={'vehicles'}
							id={'gaz_2410'}
							size={96}
						/>
					)}
					{getImageType(type) === 'realty' && (
						<StyledImage src={realtyExample} $type={type} />
					)}
					{getImageType(type) === 'other' && (
						<CollectionImage collection={'items'} id={'baconizer'} size="lg" />
					)}
					{getImageType(type) === 'clothes' && (
						<StyledImage src={tshirt} $type={type} width={120} height={120} />
					)}
					{/* {@TODO: timestamp} */}
					{time && appType === Apps.Ads ? (
						<StyledInfoHintContainer $position={'left'}>
							<StyledInfoHint>
								<Text>12:34</Text>
							</StyledInfoHint>
						</StyledInfoHintContainer>
					) : null}
					{participants ? (
						<StyledInfoHintContainer $position={'left'}>
							<StyledParticipantsHint>
								<ImgIcon icon={group} width={10} height={10} />
								<Text>{participants}</Text>
							</StyledParticipantsHint>
						</StyledInfoHintContainer>
					) : null}
					{type === AppAdsTypes.Vehicle && vehicleNumberPlate && (
						<StyledInfoHintContainer $position={'right'}>
							<NumberplatePreview
								numberPlate={vehicleNumberPlate}
								size={NumberPlatePreviewSize.Size20}
							/>
						</StyledInfoHintContainer>
					)}
					{time && appType === Apps.Auction ? (
						<StyledInfoHintContainer $position={'right'}>
							<StyledInfoHint>
								<Text>
									2 <span>ч.</span> 35 <span>сек.</span>
								</Text>
							</StyledInfoHint>
						</StyledInfoHintContainer>
					) : null}
				</StyledImageContainer>

				{/* <StyledInfoHint style={{ top: 20, right: 20 }}> */}
				{/* 	<Text>Отчет</Text> */}
				{/* </StyledInfoHint> */}
			</StyledTopContainer>
			<StyledBottomContainer>
				<Text className={'name'}>BMW M2 G87</Text>
				<StyledInfoContainer>
					<div className={'price'}>
						{priceFrom && <Text className={'from'}>от</Text>}
						{appType === Apps.Ads && (
							<StyledCurrencyIcon $icon={rubleIcon || ''} />
						)}
						{appType === Apps.Auction && (
							<ImgIcon icon={takeAuction} width={14} height={14} />
						)}
						<Text>{price?.toLocaleString('ru-RU')}</Text>
					</div>
					<StyledStatsContainer>
						<StyledStatContainer>
							<StyledStatsIcon $icon={eye} />
							<Text>123</Text>
						</StyledStatContainer>
					</StyledStatsContainer>
				</StyledInfoContainer>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { DefaultAppItemCard };
